import styled from 'styled-components/macro';

import { darkGray } from '../../../../../config/colors';

export const NoDataMessage = styled.div`
  color: ${darkGray};
  text-align: center;
`;
